export default "__VITE_ASSET__CJvZfxpM__"